import { Button } from '@iwoca/orion';

import styles from './SellerDashboardCreatePaylinkButton.module.css';
import { LinkWithQuery } from '../../../../components/LinkWithQuery/LinkWithQuery';
import whitePlusIcon from '../../assets/whitePlus.svg';

export const SellerDashboardCreatePaylinkButton = () => {
  return (
    <LinkWithQuery
      className={styles.payLinkButtonWrapper}
      to="/pay/pay-links/universal"
    >
      <Button>
        Create Pay Link
        <img src={whitePlusIcon} alt="" className={styles.plusIcon} />
      </Button>
    </LinkWithQuery>
  );
};
